import React from "react";
import WrapperComponent from "../../shared/WrapperComponent";
import "../Patient.css";
import AllPatientFichierContent from "../Tables/PatientFichierContent";

function FichierPatient() {
  return (
    <>
      <WrapperComponent>
        <div className="container-title-dash d-flex align-items-center gap-4 pb-4">
          <h2 className="custom-sm-top-title mb-0">Mes fichiers</h2>
        </div>

        <div className="custom-content pt-4 pb-4">
          <AllPatientFichierContent />
        </div>
      </WrapperComponent>
    </>
  );
}

export default FichierPatient;
